import React, { useEffect, useCallback, useState } from 'react'
import styled from 'styled-components'

import { Button } from 'semantic-ui-react'
import SurveyPreview from 'components/SurveyPreview'

const Wrapper = styled.div`
  &.desktop {
    display: inline-block;
    width: 100%;
    height: 420px;
    padding: 0;
    overflow: hidden;

    .scale-frame {
      width: calc(100% * 10 / 6.2);
      height: calc(420px * 10 / 6.2);
      border: 0px;
      transform: scale(0.62);
      transform-origin: 0 0;
    }
  }

  &.mobile {
    display: inline-block;
    width: 100%;
    height: 624px;
    padding: 0;
    overflow: hidden;

    .scale-frame {
      width: calc(100% * 10 / 8);
      height: calc(624px * 10 / 8);
      border: 0px;
      transform: scale(0.8);
      transform-origin: 0 0;
    }
  }
`

/**
 *
 * @param {object} props
 * @param {string} props.previewStyle
 * @param {string} props.previewURL
 * @param {Function} props.handleReloadPreview
 * @param {boolean} props.showResetButton
 * @param {boolean} props.showDeviceSwitcher
 */
export default function BrandWebSurveyLivePreview({
  previewStyle,
  previewURL,
  handleReloadPreview = null,
  showResetButton = false,
  showDeviceSwitcher = false,
}) {
  const [previewMode, setPreviewMode] = useState('desktop')

  function onPreviewModeChange(mode) {
    setPreviewMode(mode)
  }
  /**
   *
   * @param {string} message
   */
  const sendMessageToIframe = useCallback(function sendMessageToIframe(message) {
    const iframe = document.documentElement.querySelector('iframe')
    iframe.contentWindow.postMessage(
      {
        type: 'set_content',
        content: message,
      },
      '*'
    )
  }, [])

  function handleIframeLoad() {
    if (previewStyle) {
      sendMessageToIframe(previewStyle)
    }
  }

  useEffect(() => {
    if (previewStyle) {
      sendMessageToIframe(previewStyle)
    }
  }, [previewStyle, sendMessageToIframe])

  return (
    <React.Fragment>
      <SurveyPreview onChange={onPreviewModeChange} showDeviceSwitcher={showDeviceSwitcher}>
        <Wrapper className={previewMode}>
          <iframe
            className="scale-frame"
            src={previewURL}
            frameBorder={0}
            onLoad={handleIframeLoad}
          />
        </Wrapper>
      </SurveyPreview>
      {showResetButton && (
        <div className="text-center mt-2">
          <Button basic onClick={handleReloadPreview}>
            Reset survey to first question
          </Button>
        </div>
      )}
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/BrandWebSurveyLivePreview/index.js